import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Singleton pattern to prevent multiple client instances
let supabaseInstance: ReturnType<typeof createClient<Database>> | null = null;
let tokenProvider: (() => Promise<string | null>) | null = null;

// Prefer Vite env, then process.env (tests/SSR), then fallback
const viteEnv = (typeof import.meta !== 'undefined' && (import.meta as any).env) || {};
const SUPABASE_URL = viteEnv.VITE_SUPABASE_URL || process.env.VITE_SUPABASE_URL || process.env.SUPABASE_URL || "https://fyrvespwoifgpkmjnnhs.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  viteEnv.VITE_SUPABASE_ANON_KEY ||
  viteEnv.VITE_SUPABASE_PUBLISHABLE_KEY ||
  process.env.VITE_SUPABASE_ANON_KEY ||
  process.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  process.env.SUPABASE_ANON_KEY ||
  "";

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  console.warn('[supabase] Missing SUPABASE_URL or ANON_KEY. Check your .env/.env.private');
}

const resolveAccessToken = async () => {
  if (!tokenProvider) return '';
  try {
    return (await tokenProvider()) || '';
  } catch (error) {
    console.warn('[supabase] Failed to resolve access token', error);
    return '';
  }
};

function createSupabaseClient() {
  if (!supabaseInstance) {
    supabaseInstance = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      auth: {
        storage: typeof localStorage !== 'undefined' ? localStorage : undefined,
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
      },
      global: {
        headers: {
          'X-Client-Info': 'padel-app@1.0.0',
        },
      },
      accessToken: resolveAccessToken,
    });

    console.log('[supabase] Client instance created');
  }

  return supabaseInstance;
}

export const supabase = createSupabaseClient();

export function setSupabaseTokenProvider(provider: (() => Promise<string | null>) | null) {
  tokenProvider = provider;
}

export function createSupabaseClientWithSession(getToken: (() => Promise<string | null>) | null) {
  setSupabaseTokenProvider(getToken);
  return supabase;
}

export function hasSupabaseAuth() {
  return tokenProvider !== null;
}
